// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"115fd51b","223":"09e88e2a","453":"d0b39b9f","893":"a8955915","944":"e181c68a","959":"776f3ada"}[chunkId] + ".chunk.js";
};